<template>
	<!-- <div class="ui top left pointing dropdown icon labeled yellow button menu-dropdown" ref="dropdown">
		<span class="text">Dodaj gradivo</span>
	    <i class="add icon"></i>
	    <div class="menu">
      		<div class="item" data-value="free">Dodajte brezplačna interaktivna gradiva</div>
			<div class="item" data-value="code">Dodajte interaktivno gradivo z aktivacijsko kodo</div>
	    </div>
	</div> -->
	<div class="">
		<button class="ui yellow button" v-on:click="onButton('free')">Dodaj brezplačna gradiva</button>
		<button class="ui yellow button" v-on:click="onButton('code')">Dodaj gradivo z aktivacijsko kodo</button>
		<button class="ui yellow button" v-on:click="onButton('purchase')">Kupi dostop do gradiva</button>
	</div>
</template>

<script>
	require('semantic-ui/dist/semantic');

    export default {
		methods: {
			onButton(value) {
				switch(value) {
					case 'free':
						window.location.href = this.route('brezplacna-gradiva');
						break;
					case 'code':
						window.location.href = this.route('aktivacijska-koda');
						break;
					case 'purchase':
						window.open(this.route('nakup-gradiva'), '_blank');
						break;
				}
			}
		}
    }
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/IZbirkaAdd.vue